<template>
  <el-dialog custom-class="collect-result-container dialog-size-large"
             title="データ収集結果"
             :visible="true"
             :append-to-body="true"
             top="0"
             :modal="false"
             @open="$emit('open')"
             @close="$emit('close')"
             @closed="$emit('closed')">
    <div class="collect-result-container-inner">
      <fixed-header-table :fixed="collectResult.result != null && collectResult.result.count > 0"
                          style="max-height: 480px;">
        <tr slot="header">
          <th v-for="header in collectResult.result.columns">{{header}}</th>
        </tr>
        <tr v-for="row in collectResult.result.data">
          <td v-for="(val, index) in row">{{formatNumberCell(val, index)}}</td>
        </tr>
      </fixed-header-table>
      <h3 v-if="collectResult.result != null && collectResult.result.count === 0">対象のデータが見つかりませんでした</h3>
    </div>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <el-button v-if="collectResult.result !== null && collectResult.result.count > 0" type="info" class="large"  style="width: 320px; height: 50px;" @click="onClickDownload">ダウンロード
      </el-button>
    </div>
  </el-dialog>
</template>

<script lang="js">
import { CollectResult } from '../../../defines/data-collection'
import FormatUtil from '../../../utils/format'
import WebApiClient, { PostDataCollectionDownloadParam } from '../../../api/web'
import DownloadUtil from '../../../utils/donwload'

export default {
  name: 'CollectResultDialogCmp',
  components: {},
  props: {
    dataCollectionId: '',
    downloadParam: PostDataCollectionDownloadParam,
    collectResult: CollectResult
  },
  computed: {
    ignoreFormatNumberColumns () {
      return ['年月', '年', '地域コード']
    }
  },
  data () {
    return {}
  },
  methods: {
    formatNumberCell (val, index) {
      const defaultVal = '-'
      const columnName = this.collectResult.result.columns[index]

      if (this.ignoreFormatNumberColumns.indexOf(columnName) !== -1) {
        return val || defaultVal
      } else {
        return FormatUtil.formatNumber(val, defaultVal)
      }
    },

    onClickDownload () {
      return WebApiClient.postDataCollectionDownload(this, this.dataCollectionId, this.downloadParam)
        .then(response => {
          const fileName = DownloadUtil.getFileNameFromContentDisposition(response.headers['content-disposition'])
          DownloadUtil.downloadCsvBlob(response.data, fileName)
        })
    }
  }
}

</script>

<style scoped>
  .collect-result-container-inner {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .collect-result-overview.table-wrapper.fixed >>> .table-header > thead {
    padding-right: 0;
  }

  .collect-result-overview.table-wrapper.fixed >>> .table-body {
    overflow-y: hidden;
  }

</style>



// WEBPACK FOOTER //
// src/components/data-collect/dialogs/collect-result.vue